document.querySelectorAll('.btn-popup').forEach(btn => {
    btn.addEventListener('click', e => {
        let modal = e.target.parentElement.nextElementSibling;
        modal.showModal();
        modal.querySelectorAll('.mktoCheckboxList').forEach(el => {
            el.closest('.mktoFormRow').remove();
        });
        document.documentElement.style.overflow = 'hidden';
        e.preventDefault();
    })
});


document.querySelectorAll('dialog .close-button').forEach(btn => {
    btn.addEventListener('click', e => {
        let dialog = btn.parentElement;
        dialog.classList.add('hide');
        document.documentElement.style.overflow = '';
        setTimeout(function(){
            dialog.classList.remove('hide');
            dialog.close();
        }, 500);
    })
});

document.querySelectorAll('.newsletter-subscription form').forEach(form => {
    form.addEventListener('submit', e => {
        let parent = form.parentElement;
        parent.previousElementSibling?.remove();
        if (parent.closest('dialog')) {
            parent.closest('dialog').querySelector('.headline-block')?.remove();
            form.closest('.newsletter-form').style.marginBottom = 0;
            let message = `<div class="submission-popup font-fester transition-all opacity-0">
                            <h2 class="font-gilroy font-black">Thank You!</h2>
                            <p>You’re now subscribed to Toronto’s Film School’s Insider Advatange. Your newsletter will be delivered to the email address provided.</p>
                            <h3 class="font-gilroy font-black">Ready to kick-start your <span>career</span>?</h3>
                            <a class="font-gilroy" href="/request-info/">Connect me to an advisor</a>
                            </div>`;
            form.outerHTML = message;

            const offset = 150;
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = parent.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });

            setTimeout(function(){
                document.querySelector('.submission-popup').classList.remove('opacity-0')
            }, 1000);
        }
    })
})

document.querySelectorAll('.contact-form form').forEach(form => {
    form.addEventListener('submit', e => {
        let parent = form.parentElement;
        parent.previousElementSibling?.remove();
        document.querySelector('.disclaimer').remove();
        let message = `<div class="submission-popup alt font-fester transition-all opacity-0">
                        <h2 class="font-gilroy font-black">Thank <span>You!</span></h2>
                        <p>Your form has been successfully submitted.<br>An advisor will reach out to you shortly.</p>
                        <p class="font-gilroy font-black">In the meantime, we recommend you start your application to secure your spot!</p>
                        <a class="font-gilroy" href="https://yec.my.site.com/tfsapplication/s/login/?ec=302&startURL=%2Ftfsapplication%2Fs%2F&_gl=1*126wcrr*_ga*MTE1NjI4MTgzMi4xNjg1NDYwMTI0*_ga_27406196ZJ*MTcwMDg0MjU5Mi40NC4xLjE3MDA4NDI1OTMuMC4wLjA.*_ga_BGNC0JPCP3*MTcwMDg0MjU5Mi40NC4xLjE3MDA4NDI2MDQuNDguMC4w">Apply Now</a>
                        </div>`;
        form.outerHTML = message;

        const offset = 150;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = parent.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });

        setTimeout(function(){
            document.querySelector('.submission-popup').classList.remove('opacity-0')
        }, 1000);
        
    })
})


